<template>
  <pagefra>
    <div class="elevtorVideoLog">
      <panel>
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('电梯工号')">
              <el-input
                v-model="form.jobNum"
                :placeholder="$l('电梯工号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('设备号')">
              <el-input
                v-model="form.deviceSerial"
                :placeholder="$l('设备号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('用户')">
              <el-input
                v-model="form.username"
                :placeholder="$l('用户')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('请求页面')">
              <el-input
                v-model="form.pageInfo"
                :placeholder="$l('请求页面')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('是否警告')">
              <el-select v-model="form.hasWarn" :placeholder="$l('是否警告')">
                <el-option :label="$l('是否警告')" value=""></el-option>
                <el-option :label="$l('是')" value="1"></el-option>
                <el-option :label="$l('否')" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              :label="$l('序号')"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('电梯工号')"
              prop="jobNum"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('设备号')"
              prop="deviceSerial"
              align="center"
              width="120"
            ></el-table-column>
            <!-- <el-table-column
              :label="$l('设备名称')"
              prop="deviceName"
              align="center"
              width="200"
            ></el-table-column> -->
            <el-table-column
              :label="$l('用户')"
              prop="username"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('事件信息')"
              prop="eventInfo"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('是否警告')"
              prop="hasWarrn"
              align="center"
              width="120"
              :formatter="hasWarnFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('请求页面')"
              prop="pageInfo"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('记录时间')"
              prop="recordTime"
              align="center"
              width="200"
              sortable
            ></el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";
export default {
  name: "elevtorVideoLog",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        jobNum: "",
        deviceSerial: "",
        username: "",
        hasWarn: "",
        pageInfo: "",
      },
      tableData: [],
      loading: false,
    };
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_elevator_video_log_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    hasWarnFormatter(row) {
      if (row.hasWarn) {
        return "是";
      } else {
        return "否";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.elevtorVideoLog {
}
</style>
